export default __webpack_public_path__ + "static/media/PrayerMonth.46a109f4.svg";